module.exports = __webpack_public_path__ + "24e004ab/img/product-icon-grey.b248963c.svg";